import React, { Component } from "react";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });

class CategoryInput extends Component {
  state = {};
  render() {
    return (
      <div className="category">
        <div className="category_input_row max_width_500">
          <label className="hashtag hashtag_padding cursor_btn">#</label>
          <input
            type="text"
            className="category_name_input"
            value={this.props.categoryName}
            placeholder={strings.addhashtag}
            onChange={this.handleChangeCategoryName}
          />
        </div>
      </div>
    );
  }

  handleChangeCategoryName = event => {
    this.props.handleChangeCategoryName(event.target.value);
  };
}

export default CategoryInput;



// WEBPACK FOOTER //
// ./src/components/categories/category_input.jsx